import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import { Athlete } from "@/models";

const state = {
  athlete: new Athlete({}),
  athletes: [],
  athleteVideos: [],
  athleteVideosLoading: false,
  athleteLoading: false,
  athletesLoading: false,
  athleteEvents: [],
  athleteEventsLoading: false,
  meta: {},
  athleteImages: [],
  profileViews: [],
  athleteImageUpload: "",
  athleteImageUploadLoading: false,
  deleteAthleteImages: [],
  deleteAthleteImagesLoading: false,
  profileViewMeta: {},
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
